module.exports = __webpack_public_path__ + "assets/img/img249.3300ff37.png";